import { defineMessages } from 'react-intl';

export default defineMessages({
  ImsSsoTooltipNotAvailable: {
    defaultMessage: 'This setting is managed by your organization',
    id: 'ims.sso.tooltip.notAvailable',
  },
});
